export class PatientCensusRecord {
    id: number;
    shiftBlockId: number;
    costCenterId: number;
    shiftRecordId?: number;
    workflowTimeFacility: string;
    midnight?: number;
    patients: number;
    modifiedByUserName: string;
    modifiedDate: Date;
}